import { locale } from 'icreate/common/validators/yup-locale';
import * as yup from 'yup';
import { ObjectSchema, object, string, number } from 'icreate/common/validators/index';
yup.setLocale(locale);

export const categoryDisplayNameMaxLen = 50;

export class ChannelCategory {
    category: string;
    rowId: number;
}

export function CategoryValidator(existingRowIds: number[]): ObjectSchema<ChannelCategory> {
    return object({
        category: string().nonNullable().strict().required().max(categoryDisplayNameMaxLen),
        rowId: number().nonNullable().integer().required().min(1).max(10).notOneOf(existingRowIds),
    })
        .noUnknown()
        .strict();
}
